import {useTranslation} from "react-i18next";
import CalculatorIcon from "../../../Assets/SVG/CalculatorIcon";
import Space from "Components/Space";
import PageLayout from "Layouts/PageLayout";
import { useNavigate } from "react-router-dom";
import ShopifyOrderIntegrationForm from "../../../Features/Settlements/ShopifyOrderIntegrationForm";

const New = () => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    return (
        <PageLayout title={`${t('newShopifyOrderIntegration')}`} icon={<CalculatorIcon />} includeBox>
            <Space size={"large"} direction={"vertical"}>
                <ShopifyOrderIntegrationForm onSubmit={_ => navigate(-1)} />
            </Space>
        </PageLayout>
    )

}

export default New;